import Vue from "vue";
import Vuex from "vuex";
import { firebaseMutations } from "vuexfire";
import firebase from "firebase/app";
import user from "../store/user";
import installations from "../store/installations";
import zones from "../store/zones";
import devices from "../store/devices";
import statistics from "../store/statistics";
import notifications from "../store/notifications";
import i18n from "./i18n";

Vue.use(Vuex);

export default new Vuex.Store({
  mutations: firebaseMutations,
  strict: true,
  modules: {
    user: user,
    installations: installations,
    zones: zones,
    devices: devices,
    statistics: statistics,
    notifications: notifications,
  },

  actions: {
    init: function (context, user) {
      return new Promise((resolve) => {
        firebase
          .database()
          .ref("/users/" + user.uid)
          .update({ language: i18n.locale });
        context.dispatch(
          "user/setCurrentUser",
          firebase.database().ref("/users/" + user.uid)
        );
        context.dispatch(
          "notifications/setList",
          firebase.database().ref("/notifications/" + user.uid)
        );
        context
          .dispatch(
            "installations/setList",
            firebase
              .database()
              .ref("/installations2")
              .orderByChild("userid")
              .equalTo(user.uid)
          )
          .then(() => resolve());
      });
    },
  },
});
